import React from 'react'
import { Nav, NavItem, NavLink } from 'reactstrap'
import { Steps } from '../hooks/useAssignFormState'

interface StepNavigationProps {
  activeTab: number
}

const StepNavigation: React.FC<StepNavigationProps> = ({ activeTab }) => {
  return (
    <Nav className="nav-wizard">
      <NavItem className={activeTab > Steps.School ? 'done' : ''}>
        <NavLink active={activeTab === Steps.School}>
          <h5 className="mb-0">Step {Steps.School}</h5>
          Assign School
        </NavLink>
      </NavItem>
      <NavItem className={activeTab > Steps.LicenseAdmin ? 'done' : ''}>
        <NavLink active={activeTab === Steps.LicenseAdmin}>
          <h5 className="mb-0">Step {Steps.LicenseAdmin}</h5>
          License Administrator
        </NavLink>
      </NavItem>
      <NavItem className={activeTab > Steps.Confirm ? 'done' : ''}>
        <NavLink active={activeTab === Steps.Confirm}>
          <h5 className="mb-0">Step {Steps.Confirm}</h5>
          Confirmation
        </NavLink>
      </NavItem>
    </Nav>
  )
}

export default StepNavigation
